module.exports = __webpack_public_path__ + "img/content-page-promo-bg.ee55d6d.jpg";